const handleDownloadData = (toolConfig, response) => {
  if (!response) return null;

  const date_column =
    toolConfig.dataset.temporalResolution === "yearly" ? "year" : "date";
  const value_colum =
    toolConfig.dataTreatment === "absolute"
      ? toolConfig.dataset.absoluteVariable
      : toolConfig.dataset.relativeVariable;

  const columns_to_keep = [
    "country_or_region",
    date_column,
    ...(toolConfig.dataset.multipleSeries ? ["variable"] : []),
    value_colum,
  ];

  const prepareDownloadData = (response) =>
    response.map((object) =>
      columns_to_keep.reduce((acc, curr) => {
        acc[curr] = object[curr];
        return acc;
      }, {})
    );

  return prepareDownloadData(response);
};

export default handleDownloadData;
